import api from "./api";
import endpoints from "./endpoints";

export default {
  getThirdPartyLicence: async function () {
    const response = await api.get(endpoints.thirdparty.get, { params: {} });
    return response.data;
  }
};
